/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export interface IIcdDetails {
  id?: string;
  icd9Code?: string;
  icd10Code?: string;
  icd9Descrip?: string;
  icd10Descrip?: string;
  icdmetadesc?: string;
  icdng?: string;
  icddrg?: string;
  icdnum?: string;
  icdamt?: string;
  icdcoll?: string;
  icdarchive?: string;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
}

export const defaultValue: Readonly<IIcdDetails> = {
  active: false,
};
